import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.css";
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import { useNavigate } from "react-router-dom";
import Floor from "../../Services/floorServices";
import { Table as TB } from "antd";
function FloorDetails(props) {
  const columns = [
    {
      dataIndex: "floor_number",
      title: "Floor Number",
      sorter: (a, b) => a.floor_number - b.floor_number,
      responsive: ["sm"],
    },
    {
      dataIndex: "area",
      responsive: ["sm"],
      title: "Shop Area",
    },
    {
      dataIndex: "free_space",
      responsive: ["sm"],
      title: "Free Space",
    },
  ];
  const shopCols = [
    {
      dataIndex: "name",
      title: "Shop Name",
      responsive: ["sm"],
    },
    {
      dataIndex: "shop_number",
      title: "Shop Number",
      sorter: (a, b) => a.shop_number - b.shop_number,
      responsive: ["sm"],
    },
    {
      dataIndex: "area",
      responsive: ["sm"],
      title: "Shop Area",
    },
    {
      dataIndex: "occupied",
      responsive: ["sm"],
      title: "Occupied",
    },
  ];
  const shopkeeperCols = [
    {
      dataIndex: "id",
      title: "Shopkeeper ID",
      responsive: ["sm"],
    },
    {
      dataIndex: "start_date",
      responsive: ["sm"],
      title: "Start Date",
    },
    {
      dataIndex: "status",
      responsive: ["sm"],
      title: "Status",
    },
  ];

  const navigate = useNavigate();
  const [floorDetails, setFloorDetails] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isFilter, setIsFilter] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 5,
    },
  });
  const handleTableChange = (pagination, filter, sorter) => {
    setIsFilter(false);
    setTableParams({ pagination, filter, ...sorter });
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setFloorDetails([]);
    }
  };
  const getFloorDetails = async () => {
    setLoading(true);
    await Floor.getAllFloors()
      .then((data) => {
        setLoading(false);
        setFloorDetails(data.data);
        console.log("FloorDetails", data.data);
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
      });
  };

  useEffect(() => {
    getFloorDetails();
  }, []);

  return (
    <>
      {loading && (
        <div id="global-loader">
          <div class="whirly-loader"> </div>
        </div>
      )}
      <div class="page-wrapper">
        <div class="content">
          <div class="page-header">
            <div class="page-title">
              <h4>Floor List</h4>
              <h6>Manage your Floors</h6>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <div class="table-top">
                <div class="search-set">
                  <div class="search-path">
                    <a class="btn btn-filter" id="filter_search">
                      <img src="/assets/img/icons/filter.svg" alt="img" />
                      <span>
                        <img src="/assets/img/icons/closes.svg" alt="img" />
                      </span>
                    </a>
                  </div>
                  <div class="search-input">
                    <a class="btn btn-searchset">
                      <img src="/assets/img/icons/search-white.svg" alt="img" />
                    </a>
                  </div>
                </div>
                <div class="wordset">
                  <ul>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="pdf"
                      >
                        <img src="/assets/img/icons/pdf.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="excel"
                      >
                        <img src="/assets/img/icons/excel.svg" alt="img" />
                      </a>
                    </li>
                    <li>
                      <a
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="print"
                      >
                        <img src="/assets/img/icons/printer.svg" alt="img" />
                      </a>
                    </li>
                  </ul>
                </div>
              </div>

              <div class="card mb-0" id="filter_inputs">
                <div class="card-body pb-0">
                  <div class="row">
                    <div class="col-lg-12 col-sm-12">
                      <div class="row">
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Shop</option>
                              <option>Macbook pro</option>
                              <option>Orange</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Category</option>
                              <option>Computers</option>
                              <option>Fruits</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Choose Sub Category</option>
                              <option>Computer</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12">
                          <div class="form-group">
                            <select class="select">
                              <option>Brand</option>
                              <option>N/D</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg col-sm-6 col-12 ">
                          <div class="form-group">
                            <select class="select">
                              <option>Price</option>
                              <option>150.00</option>
                            </select>
                          </div>
                        </div>
                        <div class="col-lg-1 col-sm-6 col-12">
                          <div class="form-group">
                            <a class="btn btn-filters ms-auto">
                              <img
                                src="/assets/img/icons/search-whites.svg"
                                alt="img"
                              />
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* <BootstrapTable
                classes="table-responsive"
                bootstrap4
                bordered={false}
                keyField="_id"
                data={FloorDetails}
                columns={columns}
                selectRow={{ mode: "checkbox" }}
              /> */}

              <TB
                size="large"
                columns={columns}
                pagination={tableParams.pagination}
                onChange={handleTableChange}
                loading={loading}
                // expandable={{
                //   expandedRowRender: (record) => (
                //     <TB
                //       size="small"
                //       columns={shopCols}
                //       expandable={{
                //         expandedRowRender: (record) => (
                //           <TB
                //             size="small"
                //             columns={shopkeeperCols}
                //             dataSource={record.shopkeepers.map(
                //               (shopkeeper) => ({
                //                 key: shopkeeper._id,
                //                 id: shopkeeper._id,
                //                 start_date: shopkeeper.start_date,
                //                 status: shopkeeper.active
                //                   ? "Active"
                //                   : "Inactive",
                //               })
                //             )}
                //           />
                //         ),
                //         rowExpandable: (record) =>
                //           record.result?.name !== "Not Expandable",
                //       }}
                //       dataSource={record.shops.map((shop) => ({
                //         key: shop._id,
                //         shopkeepers: shop.shopkeeper,
                //         name: shop.name,
                //         shop_number: shop.shop_number,
                //         area: shop.area,
                //         occupied: shop.occupied ? "Yes" : "No",
                //       }))}
                //     />
                //   ),
                //   rowExpandable: (record) =>
                //     record.result?.name !== "Not Expandable",
                // }}
                dataSource={floorDetails?.map((item, index) => ({
                  key: item._id,
                  name: <p>{item.name}</p>,
                  shops: item.shops,
                  floor_number: item.floorNumber,
                  area: (
                    <p>
                      {item.area}m<sup>2</sup>
                    </p>
                  ),
                  free_space: (
                    <p>
                      {item.freeSpace}m<sup>2</sup>
                    </p>
                  ),
                }))}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FloorDetails;
